export class FlowConfigurationViewModel {
    static createDefault() {
        return {
            'builder:minimumIntentScore': '0.5',
            'builder:stateTrack': 'false',
            'builder:#localTimeZone': 'E.South America Standard Time',
            'builder:statesCount': '0',
            'builder:statesPublish': 'Unpublished',
        };
    }
}
